module.exports = __webpack_public_path__ + "static/media/reiki.6f028e70.jpg";